import { Button, Dialog, DialogActions, DialogContent, Grid, Typography } from '@mui/material';
import { Trash01, X } from '../../../assets';
import useNswagClient from '../../../hooks/api/useNswagClient';
import { useTranslation } from 'react-i18next';
import useLogError from '../../../hooks/useLogError';

export interface Reasons {
  onClose: () => void;
  onConfirm: () => void;
  reasonId: number;
  name: string | undefined;
}

const DeleteReasonModal = (props: Reasons) => {
  const { deleteTransactionReasons } = useNswagClient();
  const { logError } = useLogError();
  const { t } = useTranslation('manageTransactions');

  const deleteReason = () => {
    deleteTransactionReasons(props.reasonId).then(() => {
      props.onConfirm();
    })
      .catch((error) => {
        logError(error);
      });
  };
  const handleClose = () => {
    props.onClose();
  };
  return (
    <Dialog open={true}
      onClose={handleClose}
      maxWidth='md'
      fullWidth>
      <Grid
        sx={{ m: '2px' }}>
        <Grid
          sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
          <X onClick={props.onClose} />
        </Grid>
        <Grid
          sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography variant='textXL'> {t('deleteTitle')}</Typography>
        </Grid>
      </Grid>
      <DialogContent>
        <Grid sx={{ pt: '10px', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
          <Typography variant='textMD'> {t('deleteInfo')}</Typography>
        </Grid>
        <Grid sx={{ pt: '10px', display: 'flex', justifyContent: 'center', alignContent: 'center' }}>
          <Typography variant='textMD'
            sx={{ fontWeight: 'bold' }}> {props.name}</Typography>
        </Grid>
      </DialogContent>
      <DialogActions >
        <Button
          variant="secondary"
          onClick={handleClose}> {t('cancel')}</Button>
        <Button onClick={deleteReason}
          variant="bad"
        ><Trash01 />
          {t('delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteReasonModal;